import './EditPackageType.scss';
import PropTypes from 'prop-types';
import { useEffect, useState } from 'react';
import PackageType from '../../api/controllers/PackageType/PackageType';
import Error from '../../common/Error/Error';
import Packages from '../../api/controllers/Packages/Packages';

// EditPackageType Component
const EditPackageType = ({ packages, setModalOpen, refetchPackages }) => {
  const [error, setError] = useState();
  const [packageTypes, setPackageTypes] = useState([]);

  const getPackageTypes = () => {
    PackageType.all()
      .then(response => {
        setPackageTypes(response.items);
      })
      .catch(e => {
        setError(e.errors || e.error);
      });
  };

  const selectedPackageTypes = packages.map(p => p?.package?.packageType?.id);
  const selectedType = selectedPackageTypes.every(p => p == selectedPackageTypes[0])
    ? packages[0]?.package?.packageType?.id
    : '';

  const updatePackageType = packageTypeId => {
    const ids = packages.map(p => p?.package?.id);
    const data = {
      packageTypeId: packageTypeId,
    };

    Packages.update(ids, data)
      .then(() => {
        refetchPackages();
        setModalOpen(false);
      })
      .catch(e => {
        setError(e.errors || e.error);
      });
  };

  useEffect(() => {
    getPackageTypes();
  }, []);

  return (
    <div className="edit_package_type_container">
      {error && (
        <Error
          errorMessages={error}
          type={'error'}
          errorTitle={
            Array.isArray(error)
              ? `${error.length} error${
                  error.length > 1 ? 's' : ''
                } prohibited this item from being saved: `
              : ''
          }
        />
      )}
      <div className="affected_packages">
        {packages.length > 0 &&
          `This action applies to ${
            packages.length > 3
              ? `${packages.length} packages`
              : `${packages[0]?.packageName}${
                  packages[1]
                    ? `${packages.length > 2 ? ',' : ' and'} ${packages[1].packageName}`
                    : ''
                }${packages[2] ? ` and ${packages[2].packageName}` : ''}`
          } `}
      </div>
      <div className="package_type_grid">
        {packageTypes
          .sort((a, b) => a.id - b.id)
          .map(packageType => (
            <div
              className={`package_type_button ${selectedType == packageType?.id ? 'selected' : ''}`}
              key={packageType?.id}
              onClick={() => updatePackageType(packageType?.id)}
            >
              {packageType?.name}
            </div>
          ))}
      </div>
    </div>
  );
};

EditPackageType.propTypes = {
  packages: PropTypes.array,
  setModalOpen: PropTypes.func,
  refetchPackages: PropTypes.func,
};

export default EditPackageType;
